/*
 * Favoritter i nettbutikken (plan 19c-1, Gjenbruksgiganten). Logikk: docs/varesystem/logikk/favoritter-tema.md i Admin-repoet.
 *
 * Gjest: lista ligger bare i nettleseren (localStorage «gg_favoritter»: id, handle, tid), skrevet først når kunden trykker på et hjerte
 * (ekomloven § 3-15 bokstav b). Ingenting sendes til Lager.
 * Innlogget (Liquid ser kunden): Lager er fasit gjennom app proxyen /apps/gg. Kunden er den Shopify signerer, aldri en ID herfra.
 * Første visning kommer fra kundens metafelt (Liquid), og GET /apps/gg/kunde retter den ved sidelasting, tilbake-knappen og når fanen blir
 * synlig igjen. Gjestelista flettes inn i kontoen i bolker på 100, og bare det Lager bekrefter fjernes fra nettleseren.
 * Kontolista lagres aldri i nettleseren, så en gjest ser aldri en annens favoritter.
 */
(() => {
  if (window.ggFavoritter) return;
  const dataEl = document.getElementById('gg-favoritter-data');
  if (!dataEl) return;
  let cfg;
  try {
    cfg = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  const NOKKEL = 'gg_favoritter';
  const BOLK = 100;
  const SAMTIDIGE_KORT = 4;
  const T = cfg.tekster || {};
  const PROXY = cfg.proxy || '/apps/gg';
  const SIDE = cfg.side || '/pages/favoritter';
  const innlogget = cfg.innlogget === true;

  const tilId = (v) => String(v == null ? '' : v).trim();
  const gyldig = (v) => /^\d{1,20}$/.test(tilId(v));

  /* ---------- Nettleserlagringen (gjest, og kilden for flettingen) ---------- */
  let lagringVirker = true;
  let minne = []; // brukes når localStorage ikke virker (privat modus, blokkert)

  function lesGjest() {
    if (!lagringVirker) return minne.slice(); // skriving har feilet: minnelista gjelder resten av besøket (codex 2026-10-30)
    let raa;
    try {
      raa = window.localStorage.getItem(NOKKEL);
    } catch (e) {
      lagringVirker = false;
      return minne.slice();
    }
    if (!raa) return lagringVirker ? [] : minne.slice();
    try {
      const liste = JSON.parse(raa);
      if (!Array.isArray(liste)) return [];
      const sett = new Set();
      return liste
        .filter((x) => x && gyldig(x.id) && !sett.has(tilId(x.id)) && sett.add(tilId(x.id)))
        .map((x) => ({ id: tilId(x.id), handle: String(x.handle || ''), tid: Number(x.tid) || 0 }))
        .sort((a, b) => b.tid - a.tid);
    } catch (e) {
      return [];
    }
  }

  function skrivGjest(liste) {
    minne = liste.slice();
    try {
      if (liste.length) window.localStorage.setItem(NOKKEL, JSON.stringify(liste));
      else window.localStorage.removeItem(NOKKEL);
      lagringVirker = true;
      return true;
    } catch (e) {
      lagringVirker = false;
      return false;
    }
  }

  /* ---------- Tilstanden på siden ---------- */
  let liste = []; // { id, handle, tid }, nyeste først
  let antallFraLiquid = null; // innlogget før Lager har svart (metafeltet kan ha flere enn de 50 Liquid ga)
  let harLestKunde = !innlogget; // innlogget: true når GET kunde har svart med kunden
  let forsoktLest = !innlogget; // innlogget: true når første GET kunde er ferdig, uansett svar
  let proxyMangler = false; // Liquid ser kunden, proxyen gjør det ikke (401 eller innlogget: false)
  let fulltVedFletting = false;
  let flettStoppet = false; // feil, 401 eller fullt: ingen ny fletting før neste sidelasting
  let flettPagar = Promise.resolve(); // trykk venter til flettingen er ferdig, så et senere «fjern» ikke overstyres
  const bekreftet = new Map(); // id -> siste tilstand Lager har bekreftet (eller tilstanden før første ventende trykk)
  const ventende = new Map(); // id -> antall trykk som ikke er ferdig behandlet (også de som venter på flettingen)
  const iKo = () => Array.from(ventende.values()).reduce((a, b) => a + b, 0);
  let skriverAktive = 0;
  let endringsteller = 0;
  let hentIgjen = false;

  if (innlogget) {
    liste = (cfg.favoritter || []).filter((x) => x && gyldig(x.id)).map((x) => ({ id: tilId(x.id), handle: String(x.handle || ''), tid: 0 }));
    antallFraLiquid = Math.max(Number(cfg.antall) || 0, liste.length);
  } else {
    liste = lesGjest();
  }

  const har = (id) => liste.some((x) => x.id === id);

  function settLokalt(id, handle, pa) {
    liste = liste.filter((x) => x.id !== id);
    if (pa) liste.unshift({ id, handle, tid: Date.now() });
    if (antallFraLiquid !== null) antallFraLiquid = Math.max(0, antallFraLiquid + (pa ? 1 : -1));
  }

  /* ---------- Tegning: hjertene, antallet i headeren, favorittsiden ---------- */
  function tegnKnapp(knapp, pa) {
    knapp.setAttribute('aria-pressed', pa ? 'true' : 'false');
    const tekst = pa ? T.fjern : T.legg_til;
    if (!tekst) return;
    knapp.title = tekst;
    knapp.setAttribute('aria-label', knapp.dataset.tittel ? `${tekst}: ${knapp.dataset.tittel}` : tekst);
    const t = knapp.querySelector('[data-gg-fav-tekst]');
    if (t) t.textContent = tekst;
  }

  function tegnKnapper(rot) {
    const ider = new Set(liste.map((x) => x.id));
    (rot || document).querySelectorAll('[data-gg-favoritt]').forEach((k) => tegnKnapp(k, ider.has(tilId(k.dataset.ggFavoritt))));
  }

  function tegn() {
    tegnKnapper();
    const antall = antallFraLiquid !== null ? antallFraLiquid : liste.length;
    document.querySelectorAll('[data-gg-favoritter-antall]').forEach((el) => {
      el.textContent = antall > 99 ? '99+' : String(antall);
      el.hidden = antall < 1;
    });
    document.querySelectorAll('[data-gg-favoritter-antall-skjult]').forEach((el) => {
      el.textContent = antall > 0 && T.antall ? `, ${T.antall.replace('[antall]', antall)}` : '';
    });
    side.tegn();
  }

  /* ---------- Melding nederst på skjermen ---------- */
  const meldingEl = document.createElement('div');
  meldingEl.className = 'gg-fav-melding';
  meldingEl.setAttribute('role', 'status');
  meldingEl.setAttribute('aria-live', 'polite');
  document.body.appendChild(meldingEl);
  let meldingTid;

  function melding(tekst, lenke) {
    if (!tekst) return;
    meldingEl.textContent = '';
    const span = document.createElement('span');
    span.textContent = tekst;
    meldingEl.appendChild(span);
    // én lenke eller en liste (19c-2: «Se favorittene» og personvernavsnittet når en favoritt er lagt til)
    (Array.isArray(lenke) ? lenke : [lenke]).forEach((l) => {
      if (!l || !l.href || !l.tekst) return;
      const a = document.createElement('a');
      a.href = l.href;
      a.className = 'gg-fav-melding__lenke';
      a.textContent = l.tekst;
      meldingEl.appendChild(a);
    });
    meldingEl.classList.add('is-synlig');
    clearTimeout(meldingTid);
    meldingTid = setTimeout(skjulMelding, 6000);
  }

  // Skjult melding tømmes, så en usynlig lenke aldri får tastaturfokus. Har lenken fokus, venter den.
  function skjulMelding() {
    if (meldingEl.contains(document.activeElement)) {
      meldingTid = setTimeout(skjulMelding, 3000);
      return;
    }
    meldingEl.classList.remove('is-synlig');
    meldingTid = setTimeout(() => {
      if (!meldingEl.classList.contains('is-synlig')) meldingEl.textContent = '';
    }, 300);
  }

  const loggInnLenke = () => ({
    href: `/customer_authentication/login?return_to=${encodeURIComponent(window.location.pathname + window.location.search)}`,
    tekst: T.logg_inn
  });
  const sideLenke = () => (window.location.pathname === SIDE ? null : { href: SIDE, tekst: T.se_alle });
  const PERSONVERN = cfg.personvern || '';
  const lagtTilLenker = () => [sideLenke(), PERSONVERN && T.personvern ? { href: PERSONVERN, tekst: T.personvern } : null];

  /* ---------- Lager gjennom app proxyen ---------- */
  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    const b = window.crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }

  // Tidsavbrudd på alle kall, så et hengende kall aldri holder igjen kjeden trykkene venter på (codex runde 2)
  const TIDSAVBRUDD = 15000;
  // Tidsavbruddet gjelder til hele svaret er lest (codex runde 3: et svar som aldri blir ferdig, holdt ellers kjeden).
  async function hent(url, opts = {}, les = 'json') {
    const styr = typeof AbortController === 'function' ? new AbortController() : null;
    const tid = styr ? setTimeout(() => styr.abort(), TIDSAVBRUDD) : null;
    try {
      const r = await fetch(url, { ...opts, signal: styr ? styr.signal : undefined });
      let data = null;
      try {
        data = les === 'tekst' ? await r.text() : await r.json();
      } catch (e) {
        data = null;
      }
      return { status: r.status, ok: r.ok, data };
    } finally {
      clearTimeout(tid);
    }
  }

  const post = (rute, kropp) => hent(`${PROXY}/${rute}`, {
    method: 'POST',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(kropp)
  });

  let henter = null;
  function hentKunde() {
    if (!innlogget) return Promise.resolve();
    if (henter) {
      hentIgjen = true;
      return henter;
    }
    const start = endringsteller;
    henter = (async () => {
      try {
        const r = await hent(`${PROXY}/kunde`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        const d = r.data;
        if (r.status === 401) {
          proxyMangler = true;
          tegn();
          return;
        }
        if (!r.ok) return; // 429, 503 eller tidsavbrudd: behold det som vises
        if (!d || d.innlogget !== true) {
          // Liquid ser kunden, men proxyen gjør det ikke (feilen Shopify undersøker, shopify-fakta.md). Ingen lagring later som den virker.
          proxyMangler = true;
          tegn();
          return;
        }
        proxyMangler = false;
        if (iKo() > 0 || start !== endringsteller) {
          hentIgjen = true; // et trykk kom underveis: les på nytt når skrivingen er ferdig
          return;
        }
        liste = (Array.isArray(d.favoritter) ? d.favoritter : [])
          .filter((x) => x && gyldig(x.produkt_id))
          .map((x) => ({ id: tilId(x.produkt_id), handle: String(x.handle || ''), tid: Date.parse(x.lagt_til) || 0 }));
        antallFraLiquid = null;
        harLestKunde = true;
        tegn();
      } catch (e) {
        // nettverksfeil: behold det som vises
      } finally {
        henter = null;
        if (!forsoktLest) {
          forsoktLest = true;
          tegn();
        }
        if (hentIgjen && iKo() === 0) {
          hentIgjen = false;
          setTimeout(hentKunde, 250);
        }
      }
    })();
    return henter;
  }

  /* ---------- Trykk på et hjerte ---------- */
  const koer = new Map(); // én skriving om gangen per vare, i rekkefølgen kunden trykket

  function veksle(id, handle) {
    if (!gyldig(id)) return;
    const pa = !har(id);
    endringsteller += 1;

    if (!innlogget) {
      const gjest = lesGjest().filter((x) => x.id !== id);
      if (pa) gjest.unshift({ id, handle, tid: Date.now() });
      const ok = skrivGjest(gjest);
      liste = gjest;
      tegn();
      if (!ok) melding(T.uten_nettleserlagring, loggInnLenke());
      else if (pa) melding(T.lagt_til, lagtTilLenker());
      else melding(T.fjernet);
      return;
    }

    if (proxyMangler) {
      tegn();
      melding(T.logg_inn_igjen, loggInnLenke());
      return;
    }

    if (!(ventende.get(id) > 0)) bekreftet.set(id, !pa);
    ventende.set(id, (ventende.get(id) || 0) + 1);
    settLokalt(id, handle, pa);
    tegn();
    const forrige = koer.get(id) || Promise.resolve();
    const neste = Promise.all([forrige, flettPagar]).then(() => skrivTilLager(id, handle, pa));
    koer.set(id, neste);
    neste.finally(() => {
      if (koer.get(id) === neste) koer.delete(id);
    });
  }

  async function skrivTilLager(id, handle, pa) {
    skriverAktive += 1;
    let feilTekst = null;
    let lenke = null;
    try {
      if (proxyMangler) throw Object.assign(new Error('proxy'), { proxy: true });
      const r = await post(pa ? 'favoritt/legg-til' : 'favoritt/fjern', { hendelse_id: uuid(), produkt_id: id });
      if (r.ok) {
        bekreftet.set(id, pa);
        if (pa) melding(T.lagt_til, lagtTilLenker());
        else melding(T.fjernet);
        return;
      }
      if (r.status === 401) {
        proxyMangler = true;
        feilTekst = T.logg_inn_igjen;
        lenke = loggInnLenke();
      } else if (r.status === 409 && r.data && r.data.fullt) {
        feilTekst = T.fullt;
      } else if (r.status === 404) {
        feilTekst = T.finnes_ikke;
      } else {
        feilTekst = T.ikke_lagret;
      }
    } catch (e) {
      feilTekst = e && e.proxy ? T.logg_inn_igjen : T.ikke_lagret;
      if (e && e.proxy) lenke = loggInnLenke();
    } finally {
      skriverAktive -= 1;
      ventende.set(id, Math.max(0, (ventende.get(id) || 1) - 1));
      // Når siste trykk for varen er behandlet: vis det Lager sist bekreftet (en feil setter hjertet tilbake dit)
      if (ventende.get(id) === 0) {
        const fasit = bekreftet.get(id);
        if (typeof fasit === 'boolean' && har(id) !== fasit) {
          settLokalt(id, handle, fasit);
          tegn();
        }
        ventende.delete(id);
      }
      if (iKo() === 0 && hentIgjen && !henter) {
        hentIgjen = false;
        setTimeout(hentKunde, 250);
      }
    }
    melding(feilTekst, lenke);
  }

  /* ---------- Flettingen ved innlogging ---------- */
  async function flett() {
    if (!innlogget || proxyMangler || flettStoppet || !lesGjest().length) return;
    const kjor = async () => {
      let gjest = lesGjest();
      while (gjest.length) {
        const bolk = gjest.slice(0, BOLK);
        let r;
        try {
          r = await post('favoritter/flett', { hendelse_id: uuid(), varer: bolk.map((x) => ({ produkt_id: x.id })) });
        } catch (e) {
          flettStoppet = true; // lista står til neste side
          return;
        }
        if (r.status === 401) {
          proxyMangler = true;
          flettStoppet = true;
          return;
        }
        if (!r.ok || !r.data) {
          flettStoppet = true;
          return;
        }
        const ferdig = new Set([...(r.data.lagret || []), ...(r.data.ukjente || [])].map(tilId));
        // Les på nytt: en annen fane kan ha endret lista mens vi ventet
        const forrigeListe = lesGjest();
        gjest = forrigeListe.filter((x) => !ferdig.has(x.id));
        if (r.data.fullt) fulltVedFletting = true;
        // Stopp når nettleseren ikke kan ryddes, når ingenting ble borte (ellers sendes de samme igjen og igjen), og ved fullt
        if (!skrivGjest(gjest) || gjest.length >= forrigeListe.length || r.data.fullt) {
          flettStoppet = true;
          return;
        }
      }
      fulltVedFletting = false;
    };
    try {
      if (navigator.locks && typeof navigator.locks.request === 'function') {
        // Venter på en annen fane som fletter (den tømmer lista først), men aldri lenger enn tidsavbruddet
        const signal = typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(TIDSAVBRUDD * 2) : undefined;
        await navigator.locks.request('gg-favoritter-flett', signal ? { signal } : {}, () => kjor()).catch(() => {
          flettStoppet = true; // ga opp ventingen: ingen ny fletting fra denne siden (codex runde 3)
        });
      } else {
        await kjor();
      }
    } finally {
      await hentKunde();
      tegn();
    }
  }

  // Oppstart og fanefokus for innloggede: les kunden, så flett, i én kjede. Trykk venter på kjeden som gjaldt da kunden trykket, så en
  // fletting aldri legger tilbake en vare kunden fjernet (codex runde 2).
  function synk() {
    if (!innlogget) return Promise.resolve();
    const kjede = flettPagar.then(() => hentKunde()).then(() => flett()).catch(() => {});
    flettPagar = kjede;
    return kjede;
  }

  /* ---------- Siden «Mine favoritter» ---------- */
  const side = (() => {
    const rot = document.querySelector('[data-gg-favorittside]');
    if (!rot) return { tegn() {} };
    const ul = rot.querySelector('[data-gg-fav-liste]');
    const tom = rot.querySelector('[data-gg-fav-tom]');
    const fulltEl = rot.querySelector('[data-gg-fav-fullt]');
    const loggInnIgjen = rot.querySelector('[data-gg-fav-logg-inn-igjen]');
    const laster = rot.querySelector('[data-gg-fav-laster]');
    const reserveMal = rot.querySelector('template[data-gg-fav-reserve]');
    const kortCache = new Map(); // id -> li (hentet)
    const venter = new Map(); // id -> Promise
    let ko = [];
    let aktive = 0;

    function reserve(x) {
      const li = reserveMal.content.firstElementChild.cloneNode(true);
      li.dataset.produktId = x.id;
      const fjern = li.querySelector('[data-gg-fav-fjern]');
      if (fjern) {
        fjern.dataset.ggFavoritt = x.id;
        fjern.dataset.handle = x.handle;
      }
      return li;
    }

    async function hentKort(x) {
      if (x.handle) {
        try {
          const r = await hent(`/products/${encodeURIComponent(x.handle)}?section_id=favoritt-kort`, { credentials: 'same-origin' }, 'tekst');
          if (r.ok && r.data) {
            const tmp = document.createElement('div');
            tmp.innerHTML = r.data;
            const li = tmp.querySelector('[data-gg-fav-kort]');
            if (li && tilId(li.dataset.produktId) === x.id) return li;
          }
        } catch (e) {
          // faller til reservekortet
        }
      }
      return reserve(x);
    }

    function startNeste() {
      while (aktive < SAMTIDIGE_KORT && ko.length) {
        const { x, ferdig } = ko.shift();
        aktive += 1;
        hentKort(x)
          .then((li) => ferdig(li))
          .finally(() => {
            aktive -= 1;
            startNeste();
          });
      }
    }

    function kort(x) {
      if (kortCache.has(x.id)) return Promise.resolve(kortCache.get(x.id));
      if (!venter.has(x.id)) {
        venter.set(
          x.id,
          new Promise((ferdig) => {
            ko.push({ x, ferdig });
            startNeste();
          }).then((li) => {
            kortCache.set(x.id, li);
            venter.delete(x.id);
            return li;
          })
        );
      }
      return venter.get(x.id);
    }

    let tegneteller = 0;
    async function tegnSide() {
      if (fulltEl) fulltEl.hidden = !(fulltVedFletting && lesGjest().length);
      if (loggInnIgjen) loggInnIgjen.hidden = !proxyMangler;
      if (!harLestKunde) {
        // Innlogget: behold kortene fra Liquid til Lager har svart. Svarte ikke Lager, vises Liquid-lista, eller tom-teksten.
        if (forsoktLest) tom.hidden = ul.querySelector('[data-gg-fav-kort]') !== null;
        return;
      }
      const runde = ++tegneteller;
      const ider = new Set(liste.map((x) => x.id));
      // Fjern kort for varer som ikke lenger er favoritter
      ul.querySelectorAll(':scope > [data-gg-fav-kort]').forEach((li) => {
        if (!ider.has(tilId(li.dataset.produktId))) li.remove();
      });
      const finnes = new Map();
      ul.querySelectorAll(':scope > [data-gg-fav-kort]').forEach((li) => finnes.set(tilId(li.dataset.produktId), li));
      const mangler = liste.filter((x) => !finnes.has(x.id));
      tom.hidden = liste.length > 0;
      ul.hidden = liste.length === 0;
      if (laster) laster.hidden = mangler.length === 0;
      ul.setAttribute('aria-busy', mangler.length ? 'true' : 'false');
      if (mangler.length) {
        const hentet = await Promise.all(mangler.map((x) => kort(x)));
        if (runde !== tegneteller) return; // en nyere tegning har tatt over
        mangler.forEach((x, i) => finnes.set(x.id, hentet[i]));
      }
      // Rekkefølgen fra lista (nyeste først)
      liste.forEach((x) => {
        const li = finnes.get(x.id);
        if (li) ul.appendChild(li);
      });
      tegnKnapper(ul);
      if (laster) laster.hidden = true;
      ul.setAttribute('aria-busy', 'false');
    }

    return { tegn: tegnSide };
  })();

  /* ---------- Hendelser ---------- */
  document.addEventListener('click', (evt) => {
    const knapp = evt.target.closest('[data-gg-favoritt]');
    if (!knapp) return;
    evt.preventDefault();
    evt.stopPropagation();
    veksle(tilId(knapp.dataset.ggFavoritt), knapp.dataset.handle || '');
  });

  // Antallet og hjertene følger lista mellom faner (gjest)
  window.addEventListener('storage', (evt) => {
    if (evt.key !== NOKKEL || innlogget) return;
    liste = lesGjest();
    tegn();
  });

  function oppdater() {
    if (innlogget) synk();
    else {
      liste = lesGjest();
      tegn();
    }
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') oppdater();
  });
  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) oppdater();
  });

  // Kort som kommer til senere (filtrering, uendelig rulling, anbefalinger, hurtigkjøp) får riktig hjerte
  let ventendeTegning = false;
  new MutationObserver((endringer) => {
    if (ventendeTegning) return;
    const nye = endringer.some((e) => Array.from(e.addedNodes).some((n) => n.nodeType === 1 && (n.matches('[data-gg-favoritt]') || n.querySelector('[data-gg-favoritt]'))));
    if (!nye) return;
    ventendeTegning = true;
    requestAnimationFrame(() => {
      ventendeTegning = false;
      tegnKnapper();
    });
  }).observe(document.body, { childList: true, subtree: true });

  window.ggFavoritter = {
    innlogget,
    liste: () => liste.map((x) => ({ ...x })),
    proxyMangler: () => proxyMangler,
    veksle,
    oppdater
  };

  tegn();
  synk();
})();
